/**
 * Form fields for creating/editing a product in the Impact in beeld catalogus.
 * Controlled by the parent (ProductsTab) so the shared Modal's confirm button
 * can run the save. See docs/features/impact-in-beeld-hub.md.
 *
 * @param {object} props
 * @param {string} props.name - Product name value
 * @param {(value: string) => void} props.setName - Called on name input change
 * @param {string} props.priceInput - Raw price input (Dutch notation allowed)
 * @param {(value: string) => void} props.setPriceInput - Called on price input change
 * @param {string} props.openingLine - Optional opening line for the product page
 * @param {(value: string) => void} props.setOpeningLine - Called on opening-line change
 * @param {string} props.microStory - Optional micro story for the product page
 * @param {(value: string) => void} props.setMicroStory - Called on micro-story change
 * @param {string} props.formError - Validation message ('' when none)
 */
const ProductForm = ({
    name,
    setName,
    priceInput,
    setPriceInput,
    openingLine,
    setOpeningLine,
    microStory,
    setMicroStory,
    formError,
}) => {

    return (
        <div className='impact-in-beeld-product-form'>
            <label htmlFor='product-form-name'>Naam</label>
            <input
                id='product-form-name'
                type='text'
                placeholder='Bijv. Broodje gezond'
                value={name}
                onChange={(e) => setName(e.target.value)}
            />
            <label htmlFor='product-form-price'>Prijs</label>
            <input
                id='product-form-price'
                type='text'
                placeholder='Bijv. 2,50'
                value={priceInput}
                onChange={(e) => setPriceInput(e.target.value)}
            />
            <label htmlFor='product-form-opening-line'>Openingszin (optioneel)</label>
            <input
                id='product-form-opening-line'
                type='text'
                placeholder='Bijv. Met dit broodje steun je onze leerwerkplekken'
                value={openingLine}
                onChange={(e) => setOpeningLine(e.target.value)}
            />
            <label htmlFor='product-form-micro-story'>Micro-verhaal (optioneel)</label>
            <textarea
                id='product-form-micro-story'
                placeholder='Bijv. Dit product wordt gemaakt door mensen in een leerwerktraject'
                value={microStory}
                onChange={(e) => setMicroStory(e.target.value)}
            />
            {formError && <p className='impact-in-beeld-form-error'>{formError}</p>}
        </div>
    )
}

export default ProductForm
